import React from 'react'
import Button from "reactstrap/lib/Button"
import styled from 'styled-components'
import theme from 'vars/theme'


const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  margin: 24px 0;
`

const SpFooter = ({
  onBackClick,
  onNextClick,
  backButtonCaption,
  nextButtonCaption,
  backButtonDgId,
  nextButtonDgId,
}: {
  onBackClick?: () => void
  onNextClick?: () => void
  backButtonCaption?: string
  nextButtonCaption?: string
  backButtonDgId?: string
  nextButtonDgId?: string
}) => {
  return (
    <ButtonContainer>
      <Button
        type="button"
        className="px-3 py-3 font-weight-bold rounded-pill"
        style={{
          width: 150,
          backgroundColor: theme.whitePrimary,
          color: theme.grayDark,
          border: `1px solid ${theme.blueSoft10}`,
        }}
        color="secondary"
        disabled={onBackClick === undefined || onBackClick === null}
        onClick={onBackClick}
        data-dg-id={backButtonDgId}
      >
        {backButtonCaption ?? 'もどる'}
      </Button>

      <Button
        type="submit"
        className="px-3 py-3 font-weight-bold rounded-pill"
        style={{ width: 150 }}
        color="primary"
        disabled={onNextClick === undefined || onNextClick === null}
        onClick={onNextClick}
        data-dg-id={nextButtonDgId}
      >
        {nextButtonCaption ?? '次へ'}
      </Button>
    </ButtonContainer>
  )
}

export default SpFooter
